<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-box" v-for="(passenger,index) in passengers">
          <div class="form-content ">
            <form class="contact-form-action">
                <div class="row">
                  <div class="col-lg-2 responsive-column">
                    <div class="input-box">
                      <label class="label-text">İsim Soyisim</label>
                      <div class="form-group">
                        <span class="span-text">{{passenger.name}} {{passenger.lastName}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 responsive-column">
                    <div class="input-box">
                      <label class="label-text">Tc Kimlik No *</label>
                      <div class="form-group">
                        <span class="span-text">{{passenger.tckNo}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 responsive-column">
                    <div class="input-box">
                      <label class="label-text">Cinsiyet *</label>
                      <div class="form-group">
                        <span class="span-text">{{passenger.gender}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 responsive-column">
                    <div class="input-box">
                      <label class="label-text">Doğum Tarihi *</label>
                      <div class="form-group">
                        <span class="span-text">{{passenger.birthDate | ddMMyyyy }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 responsive-column">
                    <div class="input-box">
                      <label class="label-text">Pasaport</label>
                      <div class="form-group">
                        <span class="span-text">{{ passenger.passportNumber }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 responsive-column">
                    <div class="input-box">
                      <label class="label-text">Pasaport Son Geçerlilik</label>
                      <div class="form-group">
                        <span class="span-text">{{ passenger.expireDate | ddMMyyyy }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="myCruiseRoomId[passenger.cruiseRoomId] !== undefined">
                  <div class="col-lg-2 responsive-column">
                    <div class="input-box">
                      <label class="label-text">Resim *</label>
                      <div class="form-group">
                        <big-image-component :url="myCruiseRoomId[passenger.cruiseRoomId].imageUrl"></big-image-component>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 responsive-column">
                    <div class="input-box">
                      <label class="label-text">Oda Adı *</label>
                      <div class="form-group">
                        <span class="span-text">{{myCruiseRoomId[passenger.cruiseRoomId].name}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 responsive-column">
                    <div class="input-box">
                      <label class="label-text">Kabin Tipi *</label>
                      <div class="form-group">
                        <span class="span-text">{{myCruiseRoomId[passenger.cruiseRoomId].cabinType.name}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 responsive-column">
                    <div class="input-box">
                      <label class="label-text">Room Number *</label>
                      <div class="form-group">
                        <span class="span-text">{{ getCruiseRoomNumber(passenger.cruiseRoomId) }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 responsive-column">
                    <div class="input-box">
                      <label class="label-text">Ülke</label>
                      <div class="form-group">
                        <span class="span-text">{{ passenger.country }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BigImageComponent from "../common/BigImageComponent";

export default {
  name: "passengerInformationEdit",
  components: {BigImageComponent},
  computed: {
    passengers: {
      get() {
        return this.$store.getters.getPassengers;
      },
      set(value){
        this.commit("setPassengers",value);
      }
    },
    cruiseRoomList: {
      get() {
        return this.$store.getters.getCruiseRoomList;
      }
    },
    cruiseRoomMap : {
      get() {
        let cruiseRoomList = this.$store.getters.getCruiseRoomList;
        if(cruiseRoomList == null){
          return null;
        }
        return cruiseRoomList.reduce(function (map, cruiseRoom) {
          map[cruiseRoom.id] = cruiseRoom;
          return map;
        }, {});
      }
    },
    sail: {
      get() {
        return this.$store.getters.getSail
      }
    },
    booking : {
      get(){
        return this.$store.getters.getBooking;
      }
    },
    contactPhone : {
      get(){
        return this.$store.getters.getContactPhone;
      },
      set(value){
        this.$store.commit("setContactPhone",value);
      }
    },
    contactEmail : {
      get(){
        return this.$store.getters.getContactEmail;
      },
      set(value){
        this.$store.commit("setContactEmail",value);
      }
    },
    contactName : {
      get(){
        return this.$store.getters.getContactName;
      },
      set(value){
        this.$store.commit("setContactName",value);
      }
    },
    myCruiseRoomId : {
      get(){
        try{
        let sail = this.sail
        //Group by cabinType
        let map = {}
        for(let i=0;i<sail.rooms.length;i++) {
          for(let j=0;j<sail.rooms[i].cruiseRooms.length;j++){
            map[sail.rooms[i].cruiseRooms[j].id] = sail.rooms[i]
          }
        }
        return map
        }catch (e){}
        return {};
      }
    }
  },
  methods:{
    showDatePickerText(date){
      if(date == null){
        return null;
      }

      if(date instanceof moment){
        // date = date.toDate();
        return date.format('DD/MM/YYYY')
      }

      let mm = date.getMonth();
      let dd = date.getDate();
      if(mm<10){
        mm = "0"+mm
      }
      if(mm == "00"){
        mm = 12;
      }
      if(dd<10){
        dd = "0"+dd
      }
      console.log(dd+"/"+mm+"/"+date.getFullYear());
      return dd+"/"+mm+"/"+date.getFullYear();
    },
    // showDatePickerText(date){
    //   if(date == null){
    //     return null;
    //   }else if(typeof date == "string"){
    //     date = new Date(date)
    //   }
    //   let mm = date.getMonth();
    //   let dd = date.getDate();
    //   if(mm<10){
    //     mm = "0"+mm
    //   }
    //   if(mm == "00"){
    //     mm = 12;
    //   }
    //   if(dd<10){
    //     dd = "0"+dd
    //   }
    //   return dd+"/"+mm+"/"+date.getFullYear();
    // },
    addPassenger(){
      let passengers = this.$store.getters.getPassengers;
      passengers.push({
        type:"Yetişkin",
        passengerType : "ADULT",
        isTurkishCitizen:true,
        birthDate:new Date(new Date().setYear(1990))
      })
      this.$store.commit("setPassengers",passengers)
    },
    getCruiseRoomNumber(cruiseRoomId){
      if(this.cruiseRoomMap == null){
        return "-"
      }
      return this.cruiseRoomMap[cruiseRoomId].roomNumber;
    }
  },

}
</script>